<template>
  <div class="left">
    <div class="logo">
      <el-avatar
        shape="circle"
        :fit="fit"
        :size="60"
        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      ></el-avatar>
      <div class="name">{{custname}}</div>
    </div>
    <el-menu
      default-active="1-4-1"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
    >
      <el-submenu
        :index="index+''"
        v-for="(item,index) of modules"
        v-if="userfunc.indexOf(item.authName)>=0"
      >
        <template slot="title">
          <span slot="title">{{item.name}}</span>
        </template>
        <el-menu-item-group
          v-for="(items,indexs) of item.tfunc"
          v-if="userfunc.indexOf(items.authName)>=0"
        >
          <span
            slot="title"
            @click="chageItem(items.url,items.name)"
            style="cursor:default"
            @mouseenter="enter(items.name)"
            @mouseleave="leave(items.name)"
            :class="{btn_active:items.name==isActive,btn_click:items.name==clickName}"
          >{{items.name}}</span>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template> 
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "myLeft",
  props: [],
  data() {
    return {
      isCollapse: false,
      isActive: "",
      clickName: ""
    };
  },
  methods: {
    ...mapActions(["addUrl"]),
    historyBack() {
      history.back();
    },
    chageItem(url, name) {
      this.clickName = name;
      this.addUrl({ url: url, name: name });
    },
    clickRight() {
      this.$emit("click-right", "");
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    enter(name) {
      console.log(name);
      this.isActive = name;
    },
    leave(name) {
      this.isActive = "";
    }
  },
  computed: {
    ...mapState([
      "wwzqx",
      "toUser",
      "modules",
      "wwzmod",
      "footlist",
      "userfunc",
      "custname"
    ])
  },
  mounted() {}
};
</script>

<style lang="scss">
@import "../assets/basic.scss";
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
  height: 90%;
  overflow: scroll;
}
.left {
  height: 100%;
  .logo {
    width: 100%;
    padding-top: 10px;
    .name {
      width: 100%;
      text-align: center;
      line-height: 50px;
      margin-top: -50px;
    }
  }
}
.btn_active {
  color: #409eff;
  font-size: 14px;
  font-weight: 600;
}
.btn_click {
  color: #409eff;
  font-size: 14px;
  font-weight: 600;
}
</style>